var YiFeatureResponse = (function () {
    function YiFeatureResponse() {
        this.ordinaryJsEnabled = false;
        this.nonOrdinaryJsEnabled = false;
    }
    return YiFeatureResponse;
}());
export { YiFeatureResponse };
